import React from 'react'
import styled from 'styled-components'
import { pxToRem, color } from '../../utils'
import { ink } from './gridStyles'

const Wrapper = styled.div`
  flex: 1 1 auto;
  min-height: ${pxToRem(180)};
  width: 100%;
  overflow-y: auto;
  border: 1px solid ${ink.line};
  border-radius: ${pxToRem('7px')};
  background: #fff;
`

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${pxToRem(13)};
  color: ${ink.strong};
`

const Th = styled.th`
  background: ${ink.head};
  color: ${ink.strong};
  text-align: left;
  padding: ${pxToRem(9)} ${pxToRem(10)};
  font-size: ${pxToRem(10)};
  font-weight: 600;
  letter-spacing: ${pxToRem('0.8px')};
  text-transform: uppercase;
  position: sticky;
  top: 0;
  z-index: 1;
`

const Row = styled.tr`
  border-bottom: 1px solid ${ink.line};
  transition: background 0.12s ease;

  &:hover {
    background: ${ink.surface};
  }
`

const Td = styled.td`
  padding: ${pxToRem(9)} ${pxToRem(10)};
  vertical-align: top;
  line-height: 1.5;
`

const Badge = styled.span`
  display: inline-block;
  border-radius: ${pxToRem('3px')};
  padding: 0 ${pxToRem(6)};
  margin-bottom: ${pxToRem(4)};
  font-size: ${pxToRem(10)};
  letter-spacing: ${pxToRem('0.4px')};
  text-transform: uppercase;
  background: ${({ stale }) => (stale ? color.warning : color.danger)};
  color: ${({ stale }) => (stale ? '#5b666d' : '#fff')};
`

const Empty = styled.p`
  text-align: center;
  color: ${ink.soft};
  padding: ${pxToRem(24)} 0;
`

// Visão sempre legível, independente de N — e a única disponível no IE11, que não
// suporta position: sticky (sem cabeçalho fixo a grade não é interpretável).
const IncompatiblePairsList = ({ pairs, productsById }) => {
  if (!pairs.length) {
    return <Empty>Nenhum par incompatível neste escopo.</Empty>
  }

  const nameOf = id => (productsById[id] ? productsById[id].name : '---')

  return (
    <Wrapper data-grid>
      <Table>
        <thead>
          <tr>
            <Th>Produto A</Th>
            <Th>Produto B</Th>
            <Th>Motivos</Th>
          </tr>
        </thead>
        <tbody>
          {pairs.map(pair => {
            const [first, second] = pair.product_ids

            return (
              <Row key={`${first}:${second}`}>
                <Td>{nameOf(first)}</Td>
                <Td>{nameOf(second)}</Td>
                <Td>
                  {pair.stale && <Badge stale>divergência de cadastro</Badge>}
                  {pair.reasons && pair.reasons.length ? (
                    pair.reasons.map((reason, index) => (
                      <div key={index}>
                        {reason.label}: <strong>{reason.name}</strong> (declarado por{' '}
                        {nameOf(reason.declared_by)})
                      </div>
                    ))
                  ) : pair.status === 'unknown' ? (
                    <div>Motivo não carregado: o resultado foi truncado.</div>
                  ) : (
                    <div>Sem correspondência na regra atual.</div>
                  )}
                </Td>
              </Row>
            )
          })}
        </tbody>
      </Table>
    </Wrapper>
  )
}

export default IncompatiblePairsList



// WEBPACK FOOTER //
// ./src/containers/IncompatibilityAnalysis/IncompatiblePairsList.js